import {
    ValueMetricsOperationType,
    ValueMetricsProductType
} from '../../constants-types';

export type ValueMetricLimit = {
    product: ValueMetricsProductType;
    valueMetricName: string;
    displayNameTranslationKey: string;
    limit: number;
    consumed: number;
    available: number;
    metaData: { [key: string]: string };
};

export type ValueMetricTransactionUser = {
    firstName: string;
    lastName: string;
    userGuid: string;
};

export type ValueMetricTransaction = {
    id: string;
    eventTime: string;
    createdByUser: ValueMetricTransactionUser;
    product: ValueMetricsProductType;
    metricName: string;
    limit: number;
    consumed: number;
    available: number;
    operation: ValueMetricsOperationType;
};

export type TransactionTableEntry = {
    date: string;
    name: string;
    action: string;
    module: string;
};

export enum ValueMetricProductDisplayNameTRKeys {
    Unknown = '',
    HireCandidates = 'value-metrics.hire.candidate-display-name',
    HireJobs = 'value-metrics.hire.job-display-name',
    DesignTeams = 'value-metrics.design.team-display-name',
    InspireCandidates = 'value-metrics.inspire.candidate-display-name'
}
